<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('diarios')">Estimate</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>Add
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-4xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
         <select-input v-model="form.contact_id" :error="form.errors.contact_id" class="pr-6 pb-8 w-full lg:w-1/1" label="Customer">
            <option v-for="contact in contacts" :key="contact.id" :value="contact.id">{{ contact.nombres }} {{ contact.apellidos}} / {{contact.telefono}}</option>
          </select-input>
          </div>



        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Add Estimate</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Add Estimate' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    contacts: Array,
    users: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        contact_id: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('diarios.store'))
    },
  },
}
</script>
